import React, { useRef, useState } from "react";
import {
  Font,
  Page as PagePDF,
  Document as DocumentPDF,
  StyleSheet,
  BlobProvider,
} from "@react-pdf/renderer";
import { Document, Page, pdfjs } from "react-pdf";

import Header from "../components/resume/Header";
import Skills from "../components/resume/Skills";
import Education from "../components/resume/Education";
import Experience from "../components/resume/Experience";
import KeyProjects from "../components/resume/KeyProjects";
import AdditionalInfo from "../components/resume/AdditionalInfo";
import downloadImg from "../assets/images/download.svg";
import ProfessionalSummary from "../components/resume/ProfessionalSummary";
import { Spinner } from "react-bootstrap";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const globalStyles = StyleSheet.create({
  page: {
    padding: 30,
  },
  container: {
    borderBottomWidth: 0.25,
    borderBottomColor: "#112131",
    borderBottomStyle: "solid",
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  bold: {
    fontFamily: "Lato Bold",
  },
});

Font.register({
  family: "Lato",
  src: `https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf`,
});

Font.register({
  family: "Lato Italic",
  src: `https://fonts.gstatic.com/s/lato/v16/S6u8w4BMUTPHjxsAXC-v.ttf`,
});

Font.register({
  family: "Lato Bold",
  src: `https://fonts.gstatic.com/s/lato/v16/S6u9w4BMUTPHh6UVSwiPHA.ttf`,
});

function Resume({
  professionalSummary,
  skills,
  experienceData,
  resumeDownloadOptions,
}) {
  const parentRef = useRef(null);

  const [pdfBlob, setPdfBlob] = useState(null);
  const onRenderDocument = (blob) => {
    if (!pdfBlob) {
      setPdfBlob(blob?.blob);
    }
  };

  const handleDownload = () => {
    if (pdfBlob) {
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", resumeDownloadOptions.fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("PDF blob not found!");
    }
  };

  const pdfDocument = () => (
    <DocumentPDF
      author={resumeDownloadOptions.name}
      creator={resumeDownloadOptions.name}
      producer={resumeDownloadOptions.name}
      subject={`The resume of ${resumeDownloadOptions.name}`}
      title={resumeDownloadOptions.fileName}
      onRender={onRenderDocument}
    >
      <PagePDF size="A4" style={globalStyles.page}>
        <Header />
        <ProfessionalSummary professionalSummary={professionalSummary} />
        <Skills skills={skills} />
        <Experience experienceData={experienceData} />
        <KeyProjects />
        <Education />
        <AdditionalInfo />
      </PagePDF>
    </DocumentPDF>
  );

  const spinner = () => (
    <div className="d-flex align-items-center justify-content-center spinner">
      <Spinner />
    </div>
  );

  return (
    <div ref={parentRef}>
      <BlobProvider document={pdfDocument()}>
        {({ url, loading, blob }) =>
          loading ? (
            spinner()
          ) : (
            <div className="d-flex justify-content-center">
              <div className="position-fixed download-btn">
                <img
                  onClick={handleDownload}
                  src={downloadImg}
                  alt="download"
                  role="button"
                />
              </div>
              <Document file={url} loading={loading ? spinner() : null}>
                <Page
                  loading={loading ? spinner() : null}
                  pageNumber={1}
                  error={"Error"}
                  width={parentRef.current?.clientWidth}
                  scale={0.98}
                />
              </Document>
            </div>
          )
        }
      </BlobProvider>
    </div>
  );
}

export default Resume;
